"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const toggles_1 = require("../../shared/typography/toggles");
const Circle = styled_components_1.default.div `
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: 50%;
  display: flex;
  height: 1.5rem;
  justify-content: center;
  transition: ${({ theme }) => theme.utils.transition.default};
  width: 1.5rem;
`;
const InnerCircle = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.greyBase};
  border-radius: 50%;
  opacity: 0;
  height: 1.125rem;
  width: 1.125rem;
`;
const Radio = (0, react_1.forwardRef)(({ value, className, label, name, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(toggles_1.TogglesWrapper, { className: className, children: [(0, jsx_runtime_1.jsx)("input", { ...props, ref: ref, type: "radio", name: name, value: value }, void 0), (0, jsx_runtime_1.jsxs)(toggles_1.TogglesLabel, { htmlFor: value.toString(), onClick: (e) => {
                    var _a, _b;
                    (_b = (_a = e.currentTarget.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector("input")) === null || _b === void 0 ? void 0 : _b.click();
                }, children: [(0, jsx_runtime_1.jsx)(Circle, { children: (0, jsx_runtime_1.jsx)(InnerCircle, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: label }, void 0)] }, void 0)] }, void 0));
});
exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map